import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "./Store/slices/cartSlice";
import AppLayout from "./app/layout/AppLayout";
import { message } from "antd";
import AppRoutes from "./app/routes/AppRoutes";
import { useTranslation } from "react-i18next";

const Home = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart.items);
  const handleClick = (item) => {
    dispatch(addToCart(item));
    message.success(t("addToCart", "Add to cart"));
  };
  return (
    <AppLayout cartCount={cart.length}>
      <AppRoutes cart={cart} handleClick={handleClick} />
    </AppLayout>
  );
};

export default Home;
